<template>
    <div>
        <div class="search-top">
            <span>年份</span>
            <el-select class="top-choose" v-model="search.year">
                <el-option v-for="item in bonusYearOptions" :key="item" :value="item" >
                </el-option>
            </el-select>
            <span>周期</span>
            <el-select class="top-choose" v-model="search.cycle_id" z-noData-text="请先选择年份">
                <el-option v-for="item in bonusCycleOptions" :key="item.id" :label="item.cycle_number_show" :value="item.id">
                </el-option>
            </el-select>
            <div class="back-btn blue" @click="searchData()">查询</div>
        </div>

        <div class="back-list">
            <div class="list-head">
                <div>虚拟币名称</div>
                <div>预算发放总额</div>
                <div>BU已使用预算</div>
                <div>汇率设置</div>
            </div>

            <div v-form="'back-exchange'">
                <div class="list-item"  v-for="item in bi_arr" :key="item.id">
                    <div>{{ item.currency_name }}</div>
                    <div>{{ item.currency_type == 20?'————':item.total_bgt }}</div>
                    <div>{{ item.currency_type == 20?'————':item.used_bgt }}</div>
                    <div>
                        <!-- 非当期 -->
                        <span v-show="confirm_id != now_cycle.id || item.currency_type=='20'">{{ item.rate }}</span>
                        <!-- 当期 -->
                        <input v-show="confirm_id == now_cycle.id && item.currency_type=='10'" class="rate" v-model="item.rate"  v-tar="item.rate" rule="rate">
                        <div v-show="confirm_id == now_cycle.id && item.currency_type=='10'" class="back-btn" @click="showPop(item)">辅助设置</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="btns" v-if="confirm_id == now_cycle.id">
            <div class="back-btn blue" :class="{disabled:!now_form.changeFlag}" @click="saveSet">保存</div>
            <div class="back-btn" @click="backset" :class="{disabled:!now_form.changeFlag}">取消</div>
        </div>

        <!-- <transition name="fade"> -->
            <z-windowPop :show="popflag" :btnshow="true" @confirm="confirmRate" @cancel="popflag = false" :title="`辅助设置汇率（${pop_title}）`">
                <div class="slot-wrap">
                    <div class="back-item">
                        <div class="back-title">周期分红总额</div>
                        <div class="back-wrap">
                            <el-input class="top-choose" v-model="pop_yuan">
                                <template slot="append">元</template>
                            </el-input>
                        </div>
                    </div>
                    <div class="back-item">
                        <div class="back-title">预算发放总额</div>
                        <div class="back-wrap text">{{ pop_budget }}</div>
                    </div>
                    <div class="back-item">
                        <div class="back-title">汇率结果</div>
                        <div class="back-wrap text" style="font-weight:600">{{ pop_rate }}</div>
                    </div>
                </div>
            </z-windowPop>
        <!-- </transition> -->
    </div>

</template>

<script>
    import { mapState,mapGetters } from "vuex";
    import { getBonusCycleOptions } from "src/control/common.js";

    export default {
        data(){
            return {
                now_cycle:{}, //当前周期
                confirm_id:"",  //点击查询按钮时候的周期id
                now_form:{},  //表单验证对象
                bi_arr:[],  //数据列表

                bonusCycleOptions:[],  //联动 周期序号列表
                search:{
                    year:"",    //搜索的年
                    cycle_id:"",  //搜索的id
                },
                // full_screenFlag:false, //全屏遮罩

                popflag:false,   //弹窗判断器
                pop_item:{},
                pop_yuan:0,
            }
        },
        computed:{
            ...mapState(["currencyList"]),  //快币列表
            ...mapGetters(["bonusYearOptions"]),  //周期年份列表
            pop_title(){ //弹窗快币名称
                return this.pop_item.currency_name;
            },
            pop_budget(){
                return this.pop_item.total_bgt;
            },
            pop_rate(){
                if( this.pop_yuan === "" ){
                    return "请输入分红金额";
                }

                if(isNaN(this.pop_yuan) || this.pop_yuan<0){
                    return "请输入正确的整数";
                }

                if( this.pop_yuan == 0 || this.pop_budget == 0){
                    return 0;
                }

                let res = this.pop_yuan/this.pop_budget;
                if(parseInt(res) !== res ){
                    res = Math.round(res*100)/100;
                }
                return res;
            },
        },
        watch:{
            "search.year"(year){
                this.bonusCycleOptions = getBonusCycleOptions(year);
                this.search.cycle_id = "";
            }
        },

        created(){
            this.$func.getBonusCycle(true,list=>{   //获取奖金周期
                this.now_cycle = list.pop();
                this.confirm_id = this.now_cycle.id;
                // 更新显示的值
                this.search.year = this.now_cycle.cycle_year;
                setTimeout(data=>{
                    this.search.cycle_id = this.now_cycle.id;
                })
                this.getNowData();  //获取当前周期数据
            });   
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-exchange',path:to.path});
			next(res);
        },
        
        methods:{
            // ***拉取数据
            getNowData(){  //拉取当前周期  汇率列表
                this.getData(this.now_cycle,data=>{
                    // 重置表单 数据
                    this.$form.init('back-exchange');
                    this.now_form = this.$form.forms['back-exchange'];
                });
            },
            getData(...arg){   //根据周期  拉取汇率列表
                let cycle = arg[0] || {};
                let func = arg[1];
                let url = `api/admin/rate/list`;
                let obj = {
                    cycle_id:cycle.id,
                    cycle_start:cycle.cycle_start,
                    cycle_end:cycle.cycle_end,
                };
                this.$http.get(url,{params:obj}).then(res=>{
                    if(res.status == 200){
                        this.bi_arr = res.res_data;
                        func && func(res.res_data);
                    }
                });
            },
            searchData(){   //查询
                let id = this.search.cycle_id;
                this.confirm_id = id;
                if(id == this.now_cycle.id){
                    this.getNowData();
                }else{
                    let cycle = this.$func.queryBonusCycle(id);
                    this.getData(cycle);
                }
            },

            // ****弹窗相关
            showPop(item){  //弹窗
                this.pop_yuan = 0;
                this.popflag = true;
                this.pop_item = item;  
            },
            confirmRate(){  //保存辅助设置结果
                if(isNaN(this.pop_rate)){
                    this.errorTip("无效的输入");
                    return;
                }
                this.pop_item.rate = this.pop_rate;
                this.popflag = false;
            },

            // ****  按钮功能
            saveSet(){  //保存
                let res = this.$form.check("back-exchange");
                if(!res){
                    return;
                }

                console.log("保存");
                this.$func.loading(true);
                let rate_arr = this.bi_arr.map(item=>{
                    return {
                        currency_id:item.currency_id,
                        rate:item.rate,
                    };
                });

                let url = `api/admin/rate`;
                this.$http.post(url,{
                    cycle_id:this.now_cycle.id,
                    rates:JSON.stringify( rate_arr ),
                }).then(res=>{
                    if(res.status == 200){
                        this.getNowData();
                        this.successTip("汇率保存成功");
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },
            backset(){ //取消
                let arr = [...this.now_form.oldValue];
                this.bi_arr.forEach((item,index)=>{
                    item.rate = arr[index];
                });
                this.$form.clear("back-exchange");
            },

        },
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/backless/var.less";
    .search-top .back-btn{
        margin-left: 15px;
    }
    .btns{
        margin-top:15px;
        &:after{
            content:"";
            display: block;
            clear:both;
        }
        .back-btn{
            float: left;
            &+div{
                margin-left:15px;
            }
        }
    }

    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 20%;
        }
        >div:nth-of-type(2){
            width: 20%;
        }
        >div:nth-of-type(3){
            width: 20%;
        }
        >div:nth-of-type(4){
            width: 20%;
        }
        // >div:nth-of-type(5){
        //     width: 20%;
        // }
        // >div:nth-of-type(6){
        //     width: 10%;
        // }
    }

    .list-item{
        // 汇率框
        .rate{
            box-sizing: border-box;
            height: 28px;
            line-height: 26px;
            width:40px;
            text-align: center;
            border: 1px solid #d9dfe7;
            color:@font_list;
            transition:0.3s;
            &:hover{
                border-color:@hover-c;
            }
            &:focus{
                border-color:@focus-c;
            }
        }
        .back-btn{
            // display:inline-block;
            // width:64px;
            line-height: 26px;
            height: 28px;
            margin-left:20px;
        }
    }

    .slot-wrap{
        float:left;
        padding-top:26px;
    }

    .back-item{
        position: relative;
        padding-left: 164px;
        .back-wrap{
             position: absolute;
             left:100%;
             top: 0;
         }
    }


</style>





// WEBPACK FOOTER //
// rate.vue?086d28a8